export const DEFAULT_NAN_MESSAGE = 'The value must be a number';
export const DEFAULT_PORCENTAGE_MESSAGE = 'The value must be a number between 0 and 100';
export const DEFAULT_ERROR_MESSAGE = 'Network Error';
export const FILE_TYPE_ERROR_MESSAGE = 'File type not allowed. Only CSV or XLSX are accepted.';
export const UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred';
export const THERE_WAS_AN_ERROR_MESSAGE = 'There was an error. Please try again';
